class Header {
	constructor() {
		this._init();
	}

	_init() {
		let $class = this;
		console.log("Header Init");

		$class.modifySlideCart();
		$class.modifyMobileMenu();


	}


	modifySlideCart() {

		var activeBuyButton;

		window.SLIDECART_LOADED = function(cart) {
			$(document).ready(function() {
				$('body').on('click', '[type="submit"]:not([name="subscribe"])', function(e) {
					$(this).addClass('button--loading');
					activeBuyButton = $(this);
					setTimeout(() => {
						$(this).removeClass('button--loading');
					}, 3000);
				});
			})
		}

		window.SLIDECART_UPDATED = function(cart) {
			// Fires whenevr slide cart has updated

			// Disable and hide Checkout form
			var form  = document.getElementById("slidecart-checkout-form");
			if(form){
				var allElements = form.elements;
				for (var i = 0, l = allElements.length; i < l; ++i) {
					// allElements[i].readOnly = true;
					allElements[i].disabled=true;
				}
				form.style.display = 'none';
			}
			//Add Cart button and take translated string from from button
			var isCartBtn = $('#slidecarthq .additional-buttons').find('.slidecarthq-button').length > 0;
			if(!isCartBtn){
				var cartText = $('#slidecart-checkout-form .button[name="checkout"]').text();
				$('#slidecarthq .additional-buttons').append('<a class="button slidecarthq-button" href="/cart">'+cartText+'</a>');
			}

			// update header cart items count
			$('#pageheader .cart__count').text('('+cart.item_count+')');

			if(activeBuyButton != undefined) {
				setTimeout(function (){
					activeBuyButton.removeClass('button--loading');
					activeBuyButton = null;
				},500);
			}
		}
	}

	modifyMobileMenu(){
		$(document).ready(function() {

			var selectedMenuItem;

			$('.main-menu-link-kc').on('click', function() {
				if ($(window).width() < 768) {

					if(selectedMenuItem && !selectedMenuItem.is($(this))){
						selectedMenuItem.siblings().slideUp();
						selectedMenuItem.removeClass('active');
						selectedMenuItem = null;
					}

					$(this).siblings().slideToggle();
					$(this).toggleClass('active');

					selectedMenuItem = $(this);

				}
			});
		});
	}

}

export default Header
